import { forkJoin, fromEvent, Subscription } from 'rxjs';
import { BookingContainer } from './booking.container';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Component, OnInit, HostListener } from '@angular/core';
import { Location, PlatformLocation } from '@angular/common';
import { environment } from '../../../environments/environment';
import { Angulartics2 } from 'angulartics2';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
declare const fbq: any;
@Component({
    selector: 'app-hotel-booking',
    templateUrl: 'booking.component.html',
    styleUrls: ['booking.component.css', 'booking.component.scss']
})

export class BookingComponent implements OnInit {

    offerId;
    guestDetails = new Array<any>();
    guestDeatailsDisabled;
    estimatedTimes = new Array<string>();
    estimatedEndTimes = new Array<string>();
    etaValue: any;

    private cancelBackEvent: Subscription;

    countries = ['-', 'Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla',
        'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas',
        'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan',
        'Bolivia, Plurinational State of', 'State of Bonaire Sint Eustatius and Saba', 'Bosnia and Herzegovina',
        'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina',
        'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic Central', 'Chad',
        'Chile', 'China', 'Christmas', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo,', 'Cook', 'Costa', 'Côte',
        'Croatia', 'Cuba', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica Dominica', 'Dominican Republic',
        'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland', 'Faroe Islands',
        'Fiji', 'Finland', 'France', 'French', 'French', 'French', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar',
        'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana',
        'Haiti', 'Heard Island and McDonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland',
        'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan',
        'Kazakhstan', 'Kenya', 'Kiribati', 'Korea,', 'Korea,', 'Kuwait', 'Kyrgyzstan', 'Lao', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia',
        'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia,', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives',
        'Mali', 'Malta', 'Marshall', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia', 'Moldova', 'Monaco',
        'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
        'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern', 'Norway', 'Oman',
        'Pakistan', 'Palau', 'Palestinian', 'Panama', 'Papua', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal',
        'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Barthélemy', 'Saint Helena,',
        'Saint Kitts', 'Saint Lucia', 'Saint Martin', 'Saint Pierre', 'Saint Vincent', 'Samoa', 'San Marino', 'Sao Tome',
        'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten(Dutch part)',
        'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Sudan', 'Spain',
        'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian',
        'Taiwan, Province of China', 'Tajikistan', 'Tanzania,', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga',
        'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda',
        'Ukraine', 'United ArabEmirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands',
        'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela,', 'Viet', 'Virgin Islands, British', 'Virgin Islands, U.S. ',
        'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'];

    selectedValue = this.countries[this.countries.indexOf('Greece')];

    constructor(private route: ActivatedRoute, private spinner: NgxSpinnerService,
        private bookingContainer: BookingContainer,
        private router: Router,
        protected location: Location, private platformLocation: PlatformLocation, private angulartics2: Angulartics2) {
        this.route.params.subscribe(params => {
            if (params['id']) {
                this.offerId = params['id'];
            }
        });
        /* platformLocation.onPopState(() => {
            confirm('Going back to the property will reset your selections');
            window.location.reload();
        });*/
        this.preventBackButton();
    }

    preventBackButton() {

        history.pushState(null, null, location.href);
        const currentPath = this.location.path();
        this.cancelBackEvent = fromEvent(window, 'popstate').subscribe(() => {
            Swal.fire({
                title: 'Going back to the property will reset your selections',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.cancelBackEvent.unsubscribe();
                    this.location.back();
                    setTimeout(() => {
                        window.location.reload();
                    }, 300);
                    setTimeout(() => {
                        if (this.location.isCurrentPathEqualTo(currentPath)) {
                            this.location.back();
                        }
                    }, 500);
                } else {
                    history.pushState(null, null, location.href);
                }
            });
        });

    }

    ngOnInit() {
        this.hidePropertyButton();
        this.hideSecondaryMenu();
        // this.offerId = this.route.pathFromRoot[1].snapshot.paramMap.get('id');
        /*this.route.params.subscribe(params => {
          if (params['id']) {
            this.offerId = params['id'];
          }
        });*/
        this.bookingContainer.populateWithData(this.offerId);
        this.bookingContainer.changeHeaderType('booking');
        for (let i = 11; i < 24; i++) {
            let time = '';
            if (i < 10) {
                time = '0' + i + ':00';
            } else {
                time = i + ':00';
            }
            this.estimatedTimes.push(time);
            this.estimatedEndTimes.push(time);
        }
        for (let i = 0; i < 11; i++) {
            let time = '';
            if (i < 10) {
                time = '0' + i + ':00';
            } else {
                time = i + ':00';
            }
            this.estimatedTimes.push(time);
            this.estimatedEndTimes.push(time);
        }
        this.estimatedEndTimes.push('24:00');

        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
        this.etaValue = this.estimatedTimes[0] + '-' + this.estimatedEndTimes[1];
        if (environment.production) {
            this.angulartics2.eventTrack.next({
                action: 'PageView',
                // properties: { content_name: 'Home Page' },
            });
            this.angulartics2.pageTrack.next({ path: '/booking' });
            fbq('track', 'ViewContent', {});
        }
    }

    getFacilitiesTab = () => this.bookingContainer.facilitiesTab;
    getOfferInfo = () => this.bookingContainer.offerInfo;
    getLanguages = () => this.bookingContainer.languages;
    getCheckin = () => this.bookingContainer.checkinout;
    getPricingPolicy = () => this.bookingContainer.pricingPolicy;
    getUser = () => this.bookingContainer.user;
    getBookingRequest = () => this.bookingContainer.bookingRequest;
    getHotelInfo = () => this.bookingContainer.hotelInfo;
    getSelectedRooms = () => this.bookingContainer.selectedRooms;
    getFinalRooms = () => this.bookingContainer.finalRooms;
    getOfferNote = () => this.bookingContainer.offerNote;
    getFinalWishes = () => this.bookingContainer.finalWishes;
    getOfferId = () => this.bookingContainer.offerId;
    getMapInfo = () => this.bookingContainer.getMapInfo();
    getCardsAccepted = () => this.bookingContainer.cardsAccepted;

    getGuestDetails() {
        if (this.guestDetails.length > 0 && this.guestDetails.length === this.bookingContainer.selectedRooms.length) {
            return this.guestDetails;
        }
        /*if (this.bookingContainer.bookingRequest === null || this.bookingContainer.bookingRequest === undefined) {
            return;
        }*/
        this.guestDetails = new Array();
        // if (this.bookingContainer.bookingRequest.user === null) {
        this.bookingContainer.selectedRooms.forEach(room => {
            const user = this.bookingContainer.getUserInfo();
            const details = {
                firstName: '', lastName: '',
                email: user.email, phone: '', country: '',
                arrivalTime: '', roomId: room.room.id
            };
            this.guestDetails.push(details);
        });
        // } else {
        /*this.bookingContainer.selectedRooms.forEach(room => {
            const details = {
                firstName: this.bookingContainer.bookingRequest.user.name,
                lastName: this.bookingContainer.bookingRequest.user.surname,
                email: this.bookingContainer.bookingRequest.user.email,
                phone: this.bookingContainer.bookingRequest.user.phone,
                country: this.bookingContainer.bookingRequest.user.country,
                arrivalTime: '',
                roomId: room.room.id
            };
            this.guestDetails.push(details);
        });*/
        // }
        return this.guestDetails;
    }

    prepareForBooking(data) {
        this.spinner.show();
        this.guestDetails = data[0];
        this.bookingContainer.setBookNowClickedState(true);
        setTimeout(() => {
            this.spinner.hide();
        }, 2000);
    }

    saveCreditCardDetails(ccInfo) {
        const servicedata = {
            account: ccInfo.account.toString(),
            fname: ccInfo.fname,
            lname: ccInfo.lname,
            secCode: ccInfo.secCode,
            type: ccInfo.type,
            endDate: ccInfo.endDate,
            country: ccInfo.country,
            user: this.bookingContainer.getUserId()
        };

        this.bookNowNew(servicedata);
    }

    bookNow(servicedata) {
        const bookingOffer = this.bookingContainer.offerInfo.offer;
        bookingOffer.acceptedDate = new Date();
        bookingOffer.status = 1;


        // this.bookingContainer.enableSpinner(true);
        this.bookingContainer.saveServiceData(servicedata).subscribe(serviceReply => {
            if (serviceReply === null || serviceReply === undefined) {
                return;
            }
            const bookingServiceData = {
                bookingOffer: parseInt(this.bookingContainer.offerId, 10),
                serviceData: serviceReply.id,
                validDetails: true,
                viewCount: 0
            };

            bookingOffer.bookingOfferServiceData = [bookingServiceData];

            this.bookingContainer.saveBookOffer(bookingOffer).subscribe(reply => {
                const observableBatch = [];
                const bookedRooms = new Array();
                this.guestDetails.forEach(guestDetail => {
                    //                  console.log(guestDetail);
                    const bookingOfferRoomId = guestDetail.roomId;
                    const res = this.bookingContainer.selectedRooms.find(e => e.room.id === bookingOfferRoomId);
                    let bookingOfferRoom = null;
                    if (res !== null && res !== undefined) {
                        bookingOfferRoom = res.room;
                    } else {
                        alert('something went wrong!');
                        return;
                    }// something went wrong

                    bookingOfferRoom.booked = true;
                    bookingOfferRoom.bookingOffer = parseInt(this.bookingContainer.offerId, 10);
                    //                  console.log(bookingOfferRoom);

                    //                  var customerModels = bookingOfferRoom.get('bookingOfferRoomCustomer');
                    const roomGuestData = {
                        firstName: guestDetail.firstName,
                        lastName: guestDetail.lastName,
                        email: guestDetail.email,
                        phone: guestDetail.phone,
                        country: guestDetail.country,
                        arrivalTime: guestDetail.arrivalTime,
                        bookingOfferRoomId: bookingOfferRoomId,
                        id: bookingOfferRoom.bookingOfferRoomCustomer.length > 0 ? bookingOfferRoom.bookingOfferRoomCustomer[0].id : ''
                    };
                    bookingOfferRoom.bookingOfferRoomCustomer = [roomGuestData];
                    bookedRooms.push(bookingOfferRoom);
                    observableBatch.push(this.bookingContainer.saveRoomOffer(bookingOfferRoom));
                    /*.subscribe(roomReply => {
                    console.log(roomReply);
                    //Enable SPinner
                    //Navigate to voucher
                    //this.router.navigate('/confirmation/'+self.bookingOfferVo.get('id'), {trigger: true});
                });*/
                });

                forkJoin(observableBatch).subscribe(arg => {
                    // initialize message thread
                    this.initializeMessageThread();
                    this.sendBookingConfirmationEmail(this.bookingContainer.offerId);
                    const totalCost = this.getTotalCost(this.getSelectedRooms());
                    fbq('track', 'Purchase', {
                        // content_ids: this.offerInfo.hotel.id,
                        currency: 'EUR',
                        value: totalCost
                    });
                    this.router.navigate(['/booking/' + this.offerId + '/' + this.bookingContainer.offerInfo.hotel.id + '-thankyou']);
                    // this.bookingContainer.enableSpinner(false);
                });
            });
        });




        // const baseUrl = window.location.origin + window.location.pathname; // + window.location.pathname +

    }
    bookNowNew(servicedata) {
        const bookingOffer = this.bookingContainer.offerInfo.offer;
        bookingOffer.acceptedDate = new Date();
        // bookingOffer.status = 1;
        // this.bookingContainer.enableSpinner(true);
        this.bookingContainer.saveServiceData(servicedata).subscribe(serviceReply => {
            if (serviceReply === null || serviceReply === undefined) {
                return;
            }
            const bookingServiceData = {
                bookingOffer: bookingOffer.id,
                serviceData: serviceReply.id,
                validDetails: true,
                viewCount: 0
            };
            bookingOffer.bookingOfferServiceData = [bookingServiceData];
            bookingOffer.hotelid = parseInt(this.bookingContainer.offerId, 10);

            const observableBatch = [];
            const bookedRooms = new Array();
            this.guestDetails.forEach(guestDetail => {
                //                  console.log(guestDetail);
                const bookingOfferRoomId = guestDetail.roomId;
                const res = this.bookingContainer.selectedRooms.find(e => e.room.id === bookingOfferRoomId);
                let bookingOfferRoom = null;
                if (res !== null && res !== undefined) {
                    bookingOfferRoom = res.room;
                } else {
                    alert('something went wrong!');
                    return;
                }
                bookingOfferRoom.booked = true;
                bookingOfferRoom.bookingOffer = bookingOffer;
                // bookingOfferRoom.bookingOffer.status = 1;
                const etaVal = <HTMLSelectElement>document.getElementById('etaVal');
                const roomGuestData = {
                    firstName: guestDetail.firstName,
                    lastName: guestDetail.lastName,
                    email: guestDetail.email,
                    phone: guestDetail.phone,
                    country: this.selectedValue.toString(),
                    arrivalTime: etaVal.options[etaVal.selectedIndex].text,
                    bookingOfferRoomId: bookingOfferRoomId,
                    id: bookingOfferRoom.bookingOfferRoomCustomer.length > 0 ? bookingOfferRoom.bookingOfferRoomCustomer[0].id : ''
                };
                bookingOfferRoom.bookingOfferRoomCustomer = [roomGuestData];
                bookedRooms.push(bookingOfferRoom);
                observableBatch.push(this.bookingContainer.saveRoomNew(bookingOfferRoom));
                this.bookingContainer.guestEmail = guestDetail.email;
                /*.subscribe(roomReply => {
                console.log(roomReply);
                //Enable SPinner
                //Navigate to voucher
                //this.router.navigate('/confirmation/'+self.bookingOfferVo.get('id'), {trigger: true});
            });*/
            });
            forkJoin(observableBatch).subscribe(arg => {
                // initialize message thread
                this.initializeMessageThread();
                this.sendBookingConfirmationEmail(this.bookingContainer.offerInfo.offer.id);
                const totalCost = this.getTotalCost(this.getSelectedRooms());
                fbq('track', 'Purchase', {
                    // content_ids: this.offerInfo.hotel.id,
                    currency: 'EUR',
                    value: totalCost
                });
                this.bookingContainer.saveBookOfferSD(bookingOffer).subscribe(reply => { });
                this.router.navigate(['/booking/' + 'booked/' + this.offerId]);
                // this.bookingContainer.enableSpinner(false);
            });
            // });
        });
    }

    getNightsDifference(from, to) {
        const date1 = new Date(from);
        const date2 = new Date(to);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    getExtraCost(room) {
        let total = 0;
        room.selectedExtras.forEach(extra => total += (extra.quantity * extra.price));
        return total;
    }

    getMealCost(room) {
        let total = 0;
        room.selectedMeals.forEach(extra => total += (extra.quantity * extra.price));
        return total;
    }

    getTotalCost(rooms) {
        let totalCost = 0;
        rooms.forEach(room => {
            totalCost += (this.getMealCost(room) + this.getExtraCost(room));
            totalCost += (room.room.offerPrice * room.room.selectedRooms *
                this.getNightsDifference(this.bookingContainer.requestForSearch.fromdate, this.bookingContainer.requestForSearch.todate));
        });
        return totalCost;
    }

    sendBookingConfirmationEmail(offerID) {
        this.bookingContainer.sendConfirmationEmail(offerID, this.guestDetails[0].email);
        /*$.ajax({
            method: "GET",
            dataType: "json",
            url:app.urlBase + "entity.bookingoffer/sendBookingConfirmationEmail/"+offerID,
            data: "baseurl="+baseURL,
            success:function(data) {
                alert("Booking confirmation sent. Check your email please!");
            }
        });*/
    }

    initializeMessageThread() {
        const date = new Date();
        this.bookingContainer.sendMessage(null);
        // const messageThread;
        /*const messageThread = {
            created: date,
            modified: date,
            hotel: this.bookingContainer.offerInfo.hotel.id,
            messageCollection: new Array(),
            title: '[Reservation: ' + this.bookingContainer.offerInfo.hotel.id.toString().padStart(6, '0') + '-' +
                this.offerId.toString().padStart(6, '0') + ']'
        };

        messageThread.save({}, {
            success:function(model, response, options) {
                var threadId = model.get('id');
                if(model.get('messageCollection') && model.get('messageCollection').length>0) {
                    return;
                }
                else {
                    // create an empty message so we can get the thread by user
                    var message = new models.Message();
                    message.set('threadId', threadId);
                    message.set('customerId', self.jsonUser.id);
                    message.set('timeSent', date);
                    message.set('seqNo', 0);
                    message.set('read', true);
                    message.isNewModel = true;

                    messageThread.set('messageCollection', new Array());
                    messageThread.get('messageCollection').push(message);
                    model.save({},{
                        success:function(model, response, options) {
                            return;
                        },
                        error: function(data, response, options){
                            return;
                        }
                    });
                }
            },
            error: function(data, response, options) {
               return;
            }
        });*/
    }

    hidePropertyButton() {

        const x = document.getElementById('property');
        if (x) {
            x.style.visibility = 'hidden';
        }
    }

    hideSecondaryMenu() {

        const y = document.getElementById('menuSecond');
        if (y) {
            y.style.visibility = 'hidden';
        }
    }

    goBack() {
        this.location.back();
    }

    isMobile() {
        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }

        return false;
    }
}
